import styled from 'styled-components'
import { NotificationLevel } from '~/components/NotificationBar'
import { FlexContainer } from '~/components/Layout'

const levelColors = {
  info: 'textStrong',
  warning: 'alertWarningText',
  risk: 'alertRiskText',
}

export const StyledOrderPreview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: ${({ theme }) => theme.colors.bgCard};
  border-radius: 16px;
  border: 0.5px solid ${({ theme }) => theme.colors.borderBrand};
  width: 435px;
  position: relative;

  ${({ theme }) => theme.media.sm`
    margin-bottom: 15px;
    width: 100%;
  `}
`

export const BackButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  left: 0px;
  outline: none;
  position: absolute;
  top: 10px;
  transform: rotate(90deg);
`

export const Title = styled.div`
  box-shadow: inset 0px -1px 0px ${({ theme }) => theme.colors.borderSubtle};
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  padding: 14px 0;
  text-align: center;
  width: 100%;
`

export const CountdownTitle = styled.span`
  background: ${({ theme }) => theme.colors.bgSurface};
  padding: 4px 8px;
  border-radius: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textSubtle};
`

export const CountdownNumber = styled.span`
  font-weight: 600;
  color: #6bc7a1;
`

export const QuoteExpiredTitle = styled.span`
  background: ${({ theme }) => theme.colors.alertRiskBg};
  padding: 4px 8px;
  border-radius: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.alertRiskText};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 8px 20px 25px;
  width: 100%;
`

export const StyledDividerLite = styled.div`
  position: relative;
  height: 1px;
  border-top: 1px dashed #e6e8eb;
  margin: 8px 0;
`

export const StyledDivider = styled(StyledDividerLite)`
  margin: 16px 0;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: -8px;
    width: 8px;
    height: 16px;
    border: 0.5px solid ${({ theme }) => theme.colors.borderBrand};
    background: ${({ theme }) => theme.colors.bgBase};
  }

  &::before {
    left: -20.5px;
    border-radius: 0 16px 16px 0;
    border-left: none;
  }

  &::after {
    right: -20.5px;
    border-radius: 16px 0 0 16px;
    border-right: none;
  }
`

export const TokenRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin: 0;
  width: 100%;
`

export const StyledTokenLabel = styled(FlexContainer)`
  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textStrong};
`

export const StyledTokenNetworkLabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16.8px;
  color: ${({ theme }) => theme.colors.textCaption};
`

export const TokenValue = styled.div`
  color: ${({ theme }) => theme.colors.textTertiary};
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
`

export const TokenAmount = styled.div`
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 20px;
  font-weight: 500;
  line-height: 120%;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 20px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.textCaption};
`

export const StyledTipValue = styled.span`
  display: flex;
  color: ${({ theme }) => theme.colors.textStrong};
  letter-spacing: 0.2px;
`

export const StyledGreenShield = styled.img`
  width: 14px;
  height: 16px;
  cursor: pointer;
`

export const StyledDetailValue = styled.span<{ level?: NotificationLevel }>`
  color: ${({ level = 'info', theme }) => theme.colors[levelColors[level]]};
  font-weight: ${({ level = 'info' }) => (level === 'info' ? 400 : 500)};
  letter-spacing: 0.2px;
  max-width: 195px;
  text-align: right;
  overflow-wrap: break-word;
`
